import moment from 'moment'
import { useEffect, useState } from 'react'

export const useAddGoalLastClicked = () => {
  const key = 'funderAddGoalLastClicked'
  const [isDisabled, setIsDisabled] = useState<boolean>(false)

  useEffect(() => {
    const nextWindow = localStorage.getItem(key)

    if (!nextWindow || new Date(nextWindow) < new Date()) {
      setIsDisabled(false)
      localStorage.setItem(key, '')
    } else {
      setIsDisabled(true)
    }
  }, [])

  const setNextEnableDate = () => {
    localStorage.setItem(key, moment().add(24, 'hours').toISOString())
    setIsDisabled(true)
  }

  return [isDisabled, setNextEnableDate] as const
}
